import { Action } from 'redux';
import { ResourceFilter } from './interfaces/interfaces/resource-filters.interface';
import { ResourcesListStateStructure } from './interfaces/resources-list.state.interface';

/** Note, currently not making use of the types and topics */
const INITIAL_STATE_STRUCTURE: ResourcesListStateStructure = {
  defaultMaxRecords: 1000,
  paginationSelection: 0,
  filters: {
    resourceCategories: []
  }
};


/** ACTION CLASS */
export class ResourcesListAction implements Action {
  type: string;
  resourceCategory?: string;
  resourceCategories?: string[];
  willBeChecked?: boolean;
  resourceType?: string;
  resourceTopic?: string;
  paginationSelection?: number;
}

/** ACTIONS TYPES */
const TOGGLEFLAG_RESOURCE_CATEGORY_BY_KEY = 'TOGGLEFLAG_RESOURCE_CATEGORY_BY_KEY';
const TOGGLEFLAG_RESOURCE_CATEGORIES_BY_KEY_ARRAY = 'TOGGLEFLAG_RESOURCE_CATEGORIES_BY_KEY_ARRAY';
const TOGGLEDISABLED_RESOURCE_CATEGORY_BY_KEY = 'TOGGLEDISABLED_RESOURCE_CATEGORY_BY_KEY';
const CREATE_TAG = 'CREATE_TAG';
const RESET_RESOURCE_CATEGORIES = 'RESET_RESOURCE_CATEGORIES';

/** ACTIONS */
export function toggleFlagResourceCategory(resourceCategory: string): ResourcesListAction {
  return { type: TOGGLEFLAG_RESOURCE_CATEGORY_BY_KEY, resourceCategory };
}
/** Same as above, but just with an array */
export function toggleFlagResourceCategories(resourceCategories: string[], willBeChecked: boolean): ResourcesListAction {
  return { type: TOGGLEFLAG_RESOURCE_CATEGORIES_BY_KEY_ARRAY, resourceCategories, willBeChecked };
}
export function toggleDisabledResourceCategory(resourceCategory: string): ResourcesListAction {
  return { type: TOGGLEDISABLED_RESOURCE_CATEGORY_BY_KEY, resourceCategory };
}
export function createTag(resourceCategory: string): ResourcesListAction {
  return { type: CREATE_TAG, resourceCategory };
}
export function resetResourceCategories(): ResourcesListAction {
  return { type: RESET_RESOURCE_CATEGORIES };
}

/**
 * This const's value must align with the function name of the reducer,
 * will be used to access the JSON object attribute this reducer reflects
 */
export const RESOURCES_LIST_REDUCER = 'ResourcesList';
export function ResourcesList(state: ResourcesListStateStructure = INITIAL_STATE_STRUCTURE, action: ResourcesListAction ) {

  const copiedState: ResourcesListStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case CREATE_TAG:

      /** This action is invoked to toggle from non-existent to existing */

      // Converts the lower-case values from service into BigHeadCamelCase
      const lastSlashIndex = action.resourceCategory.lastIndexOf('/');
      const tagPath = action.resourceCategory.substring(0, lastSlashIndex + 1);
      const tagName = action.resourceCategory.split(tagPath)[1];
      const upperName = tagName.split('-').map(w => {
        if (w.length > 1) {
          const firstLetter = w[0];
          const otherLetters = w.substring(1);
          return firstLetter.toUpperCase() + otherLetters;
        } else {
          return w.toUpperCase();
        }
      }).join(' ');
      const upperCatName = tagPath + upperName;

      const newCat: ResourceFilter = {
        key: action.resourceCategory,
        value: {
          checked: true,
          disabled: false,
          visible: true,
          name: upperCatName
        }
      };
      copiedState.filters.resourceCategories.push(newCat);
      return Object.assign({}, state, copiedState);

    /** Resource Category checkbox-toggle */
    case TOGGLEFLAG_RESOURCE_CATEGORY_BY_KEY:

      const matchedCat
        = copiedState.filters.resourceCategories.filter( (catItem, index) => action.resourceCategory === catItem.key );

      if (matchedCat.length > 0 && !matchedCat[0].value.disabled) {
        const isChecked = matchedCat[0].value.checked;
        matchedCat[0].value.checked = !isChecked;
      }

      return Object.assign({}, state, copiedState);

    /** Resource Category checkbox-toggle */
    case TOGGLEFLAG_RESOURCE_CATEGORIES_BY_KEY_ARRAY:

      action.resourceCategories.forEach( tag => {
        copiedState.filters.resourceCategories.some( catItem => {
          if (tag === catItem.key) {
            catItem.value.checked = action.willBeChecked;
          }
        });
      });

      return Object.assign({}, state, copiedState);

    /** Resource Category checkbox-toggle */
    case TOGGLEDISABLED_RESOURCE_CATEGORY_BY_KEY:

      const matchedCategoryName
        = copiedState.filters.resourceCategories.filter( (catItem, index) => action.resourceCategory === catItem.key );

      if (matchedCategoryName.length > 0) {
        const isDisabled = matchedCategoryName[0].value.disabled;
        matchedCategoryName[0].value.disabled = !isDisabled;
      }

      return Object.assign({}, state, copiedState);

    /** Reset Categories to default state */
    case RESET_RESOURCE_CATEGORIES:
      copiedState.filters.resourceCategories = INITIAL_STATE_STRUCTURE.filters.resourceCategories;
      return Object.assign({}, state, copiedState);

    default:
      return state;
  }
}
